import { SortableIterator } from "components/dnd";
import { SectionListItem } from "./Section";

export default SectionListItem;
export const SortableSectionListItem = SortableIterator(SectionListItem);
